import { ReactElement } from 'react';
import { RedDocumentIcon } from '@root/src/assets/images';
import Lang from '@lang/en';
import { CertificateNotFoundContainer, ResultContainer } from './styles';
import { Header, Paragraph } from '@designSystem/typings';

const CertificateNotFound = (): ReactElement => {
  return (
    <ResultContainer>
      <CertificateNotFoundContainer>
        <RedDocumentIcon />
        <Header>{Lang.healthCheckResultCertificateNotFoundText}</Header>
        <Paragraph>
          {Lang.healthCheckResultCertificateNotFoundDescriptionText}
        </Paragraph>
      </CertificateNotFoundContainer>
    </ResultContainer>
  );
};

export default CertificateNotFound;
